BiddersUtils = new function(){
  var self = this;
  this.parseNumber = function(string) {
    var number = string.replace(/[^\d\.]/g,'');
    return parseFloat(number);
  };
  this.sortBidders = function(e) {
    e.preventDefault();
    self.showOnDropDown($(this));

    var selectedOption = $(this).data('bidsSorting') || "byAmount";
    var toSort = $("#biddersList .item").detach();

    switch( selectedOption ){
      case 'byAmount':
        var sortFunction = function(li1,li2){
          var price1 = $(li1).find('p').text();
          var price2 = $(li2).find('p').text();
          price1 = self.parseNumber(price1);
          price2 = self.parseNumber(price2);
          var result = price1 > price2 ? 1 : -1;
          return result;
        };
        break;
      case 'byDescAmount':
        var sortFunction = function(li1,li2){
          var price1 = $(li1).find('p').text();
          var price2 = $(li2).find('p').text();
          price1 = self.parseNumber(price1);
          price2 = self.parseNumber(price2);
          var result = price1 < price2 ? 1 : -1;
          return result;
        };
        break
      case 'byName':
        var sortFunction = function(li1,li2){
            return $(li1).find('a').text().toLowerCase() > $(li2).find('a').text().toLowerCase() ? 1: -1;
        };
        break;
      default:
        return;
    }

    toSort.sort(sortFunction);
    $("#biddersList").append(toSort);

    $("#biddersList input:checkbox").first().change();
  };

  this.showOnDropDown = function($selected) {
    var selectedSorting = $selected.data('bidsSorting');
    var $targets = $('#sortBidsBy-drop, #sortBidsByGlobal-drop');

    $targets.find('a').removeClass('selected');
    $targets.find('a[data-bids-sorting="' + selectedSorting + '"]').addClass('selected');
    $targets.parent().find('span').text($selected.html()).data($selected.data());
  };

  this.setPreselectedBid = function(bidId) {
    var selectedListItem;
    var listItems = _.select($(".item.dataItem"), function(e, i) { return $(e).data().bidId == bidId; });
    var selectedSpan;
    if (listItems.length > 0) {
      selectedSpan = $(listItems).find("span.bidderPreselect");
    }
    if (selectedSpan) {
      $("#biddersList .item span.bidderPreselect").removeClass("pre-selected").addClass("pre-selected-no");
      $(selectedSpan).parent('.item').addClass("bidderSelected");
      $(selectedSpan).removeClass("pre-selected-no").addClass("pre-selected");
      $("#biddersList").data('bidPreselected', true);
    }
    $("#tenderActions").show();
  };

  this.preselectBidder = function() {
    var bidderLi, bidId;
    bidderLi = $(this).parents('.item-bid')
    var wasPreselected = $(this).hasClass("pre-selected");
    $("#biddersList .item span.bidderPreselect").removeClass("pre-selected").addClass("pre-selected-no");
    $("#biddersList .item.bidderSelected").removeClass("bidderSelected");
    if ( ! wasPreselected ) {
      $(this).removeClass("pre-selected-no").addClass("pre-selected");
      bidderLi.addClass("bidderSelected");
      bidId =  bidderLi.data("bidId");
      $("#biddersList").data('bidPreselected', true);
    } else {
      bidId = null;
      $("#biddersList").data('bidPreselected', false);
    }

    //preselect bidder to the server.
    if (bidId == null) {
      $("#award_buffer .button").addClass('disabled');
      $("#award_buffer .button").attr('disabled', 'disabled');
      return
    } else {
      $("#award_buffer .button").removeAttr("disabled");
      $("#award_buffer .button").removeClass('disabled');
    }

    var auth_token = $('meta[name=csrf-token]').attr('content');
    $.ajax({
      url: "preselect_bid",
      dataType: "html",
      type: "POST",
      processData: false,
      contentType: "application/json",
      data: '{ "bid_id": ' + bidId + "}",
      beforeSend: function(xhr) {
        xhr.setRequestHeader("X-Http-Method-Override", "PUT");
        xhr.setRequestHeader('X-CSRF-Token', auth_token);
      },
      success: function(response) {
        $('#award_buffer').html(response);
        $("#ajaxLoader").hide();
      },
      error: function() {
        // console.log(arguments);
      }
    });
  };

  this.biddersLoaded = false;
  this.bidders = {
    visible: [],
    restricted: [],
    bidIds: {}
  };
  this.getBidders = function(type) {
    if (!this.biddersLoaded) {
      this.reloadBidders();
      this.biddersLoaded = true;
    }
    return this.bidders[type];
  };

  this.reloadBidders = function() {
    var self = this;
    this.bidders.visible = [];
    this.bidders.restricted = [];
    this.bidders.bidIds = {};

    var biddersList = $("#biddersList .item.dataItem");
    if (biddersList.length > 1) {
      $.each(biddersList, function() {
        var bidderCheckBox = $(this).find('input:checkbox');
        var bidderChartDataIndex = $(this).find('input:hidden').val();

        if (bidderCheckBox.is(':checked')) {
          var bidderName = $(this).find('a').html().replace(/&amp;/g, '&').replace(/"/g, "'");
          self.bidders.visible.push(bidderName);

          if (!!$(this).data('bidId')) {
            var bidId = $(this).data('bidId');
            self.bidders.bidIds[bidderName] = bidId;
          }
        } else {
          self.bidders.restricted.push(bidderChartDataIndex); // bidder index (not bidder ID!)
        }
      });
    } else {
      // biddersList not available yet
      var biddersData = [];
      if (typeof(ChartData) != 'undefined' && ChartData) {
        biddersData = ChartData.totals;
      } else if (typeof(DocumentData) != 'undefined' && DocumentData) {
        biddersData = DocumentData.columns;
      }
      $.each(biddersData, function(index, data) {
        self.bidders.visible.push(data.name); // bidder name
      });
    }
  };

  this.maskBiddersList = function() {
    $("#biddersList").css("height", "50px");
    CommonUtils.maskElement("#biddersList");
  };

  this.unmaskBiddersList = function() {
    $("#biddersList").css("height", "auto");
    CommonUtils.unmaskElement("#biddersList");
  };

  this.getBiddersData = function(chartData, is_revoked) {
    var biddersData = [];
    if (chartData) {
      var minValue = 0, maxValue = 0;
      var minValueIndex, maxValueIndex;
      var biddersInfo;

      if (is_revoked)
        biddersInfo = chartData.revoked_bids;
      else
        biddersInfo = chartData.totals;

      if(biddersInfo)
       {
        $.each(biddersInfo, function(index, e){
          if (!e.is_revoked_bid && e.name != I18n.t('v4.tenders.graphs.average') && e.name != I18n.t('v4.tenders.graphs.median')) {
            if (e.total > maxValue) {
              maxValue = e.total;
              maxValueIndex = index;
            }
            if (minValue == 0 || e.total < minValue) {
              minValue = e.total;
              minValueIndex = index;
            }
          }
          biddersData.push({
            bidId: e.bid_id,
            name: e.name,
            status: e.status,
            amount: chartData.currency + " " + Highcharts.numberFormat(e.total, 0, ','),
            isMostExpensive: false,
            isLeastExpensive: false,
            isRevoked: e.is_revoked_bid
          });
        });
       }

      if(biddersData[minValueIndex] != undefined)
        biddersData[minValueIndex].isLeastExpensive = true;
      if(biddersData[maxValueIndex]!= undefined)
        biddersData[maxValueIndex].isMostExpensive = true;
    }
    return biddersData;
  };

  this.renderBiddersList = function(is_revoked) {
    var list = this.getBiddersData(ChartData, is_revoked);
    // Get bidders data from document_data
    var document_data = BiddersUtils.document_data;
    // extract bidder names from document data
    var bidder_names = _.map(document_data.columns, function(column){ return column.name; });

    var template;
    if(is_revoked)
      template = $("#revokedBiddersList .item:first");
    else
      template = $("#biddersList .item:first");

    $.each(list, function(bIndex, bValue){
      var bidderData = bValue;
      var listItem = $(template).clone().removeAttr("style");
      var pCssClass = "";
      var bidderNameTrimed = '';

      listItem.find("input#index").val(bIndex);

      // build the regular expression used to find by name
      var _regex = new RegExp(bidderData.name, 'i');
      // use underscorejs method to finf and return matches
      var _name = _.find(bidder_names, function(bidder_name) { return bidder_name.match(_regex); });

      listItem.find("a.bid-name").html(bidderData.name).attr("title", bidderData.name);

      // If outdated bids are found, add a div element with outdated styling
      if ((_name) && (_name.indexOf('outdated') > 0))
        listItem.append('<div class="out-dated">outdated bid</div>');

      switch(bidderData.name) {
        case I18n.t('v4.tenders.graphs.average'):
          //listItem.addClass("average");
          listItem.find("span.bidderPreselect").remove();
          pCssClass = "average";
          break;
        case I18n.t('v4.tenders.graphs.median'):
          listItem.find("span.bidderPreselect").remove();
          pCssClass = "median";
          //listItem.addClass("median");
          break;
        case I18n.t('v4.tenders.graphs.min'):
          listItem.find("span.bidderPreselect").remove();
          pCssClass = "min";
          break;
        case I18n.t('v4.tenders.graphs.max'):
          listItem.find("span.bidderPreselect").remove();
          pCssClass = "max";
          break;
        default:
          listItem.find("span.bidderPreselect").attr("id", "preselect_"+bIndex);
          listItem.find("p.bid-status").html(I18n.t('submitted')).addClass('submitted');
          if (bidderData.isMostExpensive) {
            pCssClass = "mostExpensiveBidder";
          } else if (bidderData.isLeastExpensive) {
            pCssClass = "leastExpensiveBidder";
          } else {
            pCssClass = "averageBidder";
          }
      }
      listItem.find("p.bid-amount").addClass(pCssClass).html(bidderData.amount);
      listItem.data("bidId", bidderData.bidId);

      if (bidderData.isRevoked) {
        listItem.find('input:checkbox').prop('checked', false);
        listItem.find("span.bidderPreselect").remove();
        listItem.find("p.bid-status").html(I18n.t(bidderData.status)).addClass('revoked');
        listItem.addClass('revoked hidden');
      }

      if (is_revoked)
        $("#revokedBiddersList").append(listItem);
      else
        $("#biddersList").append(listItem);
    });

    template.remove();
  };

  this.setupSidebarEvents = function() {
    var self = this;

    $(document).on('was-changed', '.custom-checkbox input[type="checkbox"]', function() {
      if ($(this).get(0).checked)
        $(this).closest('.custom-checkbox').parent().addClass("has-checked");
      else
        $(this).closest('.custom-checkbox').parent().removeClass("has-checked");
    });

    $('.custom-checkbox input[type="checkbox"]').each(function() {
      if ($(this).get(0).checked)
        $(this).closest('.custom-checkbox').parent().addClass("has-checked");
      else
        $(this).closest('.custom-checkbox').parent().removeClass("has-checked");
    });

    if ($("#biddersList").parent().hasClass("awarded"))
      $('.bidderPreselect').css('cursor', 'auto');
    else
      $("#biddersList span.bidderPreselect").click(this.preselectBidder);

    $("#biddersList a").click( function(){ //Click either the checkbox or the Company's name updates chart
      var checkbox = $(this).closest('.item-bid').find('input:checkbox');
      checkbox.click();
      checkbox.change();
    });

    $("#biddersList input:checkbox").change( function(){
      $(this).trigger('was-changed');
      var remainingBidders = $("#biddersList input:checkbox:checked").length;
      if (remainingBidders == 0) {
        // Don't allow uncheck of all bidders
        $(this).attr("checked", "checked");
        return alert("Need to select at least one bidder");
      }
      self.reloadBidders();

      var currentChart = $("#bids-comparison-chart");
      if (currentChart.length > 0) { //jQuery object is present
        currentChart.bidsChart("filterBidders");//redraw chart
      }
      if ($('#financeGrid').is(':visible')) {
        DocumentsFinance.refreshTableData('financeGrid');
      } else {
        DocumentsFinance.rerenderTable = true
      }
      if ($('#documents-summary-table').children().length > 0) {
        DocumentsSummary.refreshTableData('documents-summary-table');
      }
      if ($('#documentsTable').children().length > 0) {
        DocumentsTable.refreshTable();
      }
      if ($('#qualificationsTable').children().length > 0) {
        BiddersQualifications.refreshTable('qualificationsTable');
      }
    });

    //Event Binding
    $('.bids-sorting, .global-bids-sorting').click(this.sortBidders);

    this.reloadBidders();

    if (this.winning_bid_id) {
      this.setPreselectedBid(this.winning_bid_id);
    }
  };

  this.toggleRevokedBidders = function() {
    var bidder_list = $('#revokedBiddersList');
    if(bidder_list.is(':visible'))
      bidder_list.hide();
    else
      bidder_list.show();
  };




  this.winning_bid_id = null;
};

$(function(){
  //expand all
  $("#preselectRevokedBidders").delegate('.expand-all','click',function(){
    $(this).addClass("collapse-all").removeClass("expand-all");
    $("#revokedBiddersList").show();
    $(this).text("Hide revoked bidders");
  });
  //collapse all
  $("#preselectRevokedBidders").delegate('.collapse-all', 'click', function(){
    $(this).addClass("expand-all").removeClass("collapse-all");
    $("#revokedBiddersList").hide();
    $(this).text("Show revoked bidders");
  });
});
